/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { Exchange, ExchangeInterface } from "../Exchange";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "accountBalance",
        type: "address",
      },
    ],
    name: "AccountBalanceChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "clearingHouse",
        type: "address",
      },
    ],
    name: "ClearingHouseChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "baseToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "marketTwap",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "indexTwap",
        type: "uint256",
      },
    ],
    name: "FundingUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "baseToken",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint24",
        name: "maxTickCrossedWithinBlock",
        type: "uint24",
      },
    ],
    name: "MaxTickCrossedWithinBlockChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [],
    name: "candidate",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getAccountBalance",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "trader",
        type: "address",
      },
    ],
    name: "getAllPendingFundingPayment",
    outputs: [
      {
        internalType: "int256",
        name: "pendingFundingPayment",
        type: "int256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getClearingHouse",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getClearingHouseConfig",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getMarketRegistry",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "baseToken",
        type: "address",
      },
    ],
    name: "getMaxTickCrossedWithinBlock",
    outputs: [
      {
        internalType: "uint24",
        name: "",
        type: "uint24",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getOrderBook",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "trader",
        type: "address",
      },
      {
        internalType: "address",
        name: "baseToken",
        type: "address",
      },
    ],
    name: "getPendingFundingPayment",
    outputs: [
      {
        internalType: "int256",
        name: "",
        type: "int256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "trader",
            type: "address",
          },
          {
            internalType: "address",
            name: "baseToken",
            type: "address",
          },
          {
            internalType: "int256",
            name: "base",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "quote",
            type: "int256",
          },
        ],
        internalType: "struct IExchange.RealizePnlParams",
        name: "params",
        type: "tuple",
      },
    ],
    name: "getPnlToBeRealized",
    outputs: [
      {
        internalType: "int256",
        name: "",
        type: "int256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "baseToken",
        type: "address",
      },
      {
        internalType: "uint32",
        name: "twapInterval",
        type: "uint32",
      },
    ],
    name: "getSqrtMarkTwapX96",
    outputs: [
      {
        internalType: "uint160",
        name: "",
        type: "uint160",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "baseToken",
        type: "address",
      },
      {
        internalType: "uint32",
        name: "twapInterval",
        type: "uint32",
      },
    ],
    name: "getSqrtMarketTwapX96",
    outputs: [
      {
        internalType: "uint160",
        name: "",
        type: "uint160",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "marketRegistryArg",
        type: "address",
      },
      {
        internalType: "address",
        name: "orderBookArg",
        type: "address",
      },
      {
        internalType: "address",
        name: "clearingHouseConfigArg",
        type: "address",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "baseToken",
        type: "address",
      },
    ],
    name: "isOverPriceSpread",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "accountBalanceArg",
        type: "address",
      },
    ],
    name: "setAccountBalance",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "clearingHouseArg",
        type: "address",
      },
    ],
    name: "setClearingHouse",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "baseToken",
        type: "address",
      },
      {
        internalType: "uint24",
        name: "maxTickCrossedWithinBlock",
        type: "uint24",
      },
    ],
    name: "setMaxTickCrossedWithinBlock",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "setOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "trader",
        type: "address",
      },
      {
        internalType: "address",
        name: "baseToken",
        type: "address",
      },
    ],
    name: "settleFunding",
    outputs: [
      {
        internalType: "int256",
        name: "fundingPayment",
        type: "int256",
      },
      {
        components: [
          {
            internalType: "int256",
            name: "twPremiumX96",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "twPremiumDivBySqrtPriceX96",
            type: "int256",
          },
        ],
        internalType: "struct Funding.Growth",
        name: "fundingGrowthGlobal",
        type: "tuple",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "trader",
            type: "address",
          },
          {
            internalType: "address",
            name: "baseToken",
            type: "address",
          },
          {
            internalType: "bool",
            name: "isBaseToQuote",
            type: "bool",
          },
          {
            internalType: "bool",
            name: "isExactInput",
            type: "bool",
          },
          {
            internalType: "bool",
            name: "isClose",
            type: "bool",
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
          {
            internalType: "uint160",
            name: "sqrtPriceLimitX96",
            type: "uint160",
          },
        ],
        internalType: "struct IExchange.SwapParams",
        name: "params",
        type: "tuple",
      },
    ],
    name: "swap",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "base",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "quote",
            type: "uint256",
          },
          {
            internalType: "int256",
            name: "exchangedPositionSize",
            type: "int256",
          },
          {
            internalType: "int256",
            name: "exchangedPositionNotional",
            type: "int256",
          },
          {
            internalType: "uint256",
            name: "fee",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "insuranceFundFee",
            type: "uint256",
          },
          {
            internalType: "int256",
            name: "pnlToBeRealized",
            type: "int256",
          },
          {
            internalType: "uint256",
            name: "sqrtPriceAfterX96",
            type: "uint256",
          },
          {
            internalType: "int24",
            name: "tick",
            type: "int24",
          },
          {
            internalType: "bool",
            name: "isPartialClose",
            type: "bool",
          },
        ],
        internalType: "struct IExchange.SwapResponse",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "int256",
        name: "amount0Delta",
        type: "int256",
      },
      {
        internalType: "int256",
        name: "amount1Delta",
        type: "int256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "uniswapV3SwapCallback",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "updateOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class Exchange__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<Exchange> {
    return super.deploy(overrides || {}) as Promise<Exchange>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): Exchange {
    return super.attach(address) as Exchange;
  }
  connect(signer: Signer): Exchange__factory {
    return super.connect(signer) as Exchange__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ExchangeInterface {
    return new utils.Interface(_abi) as ExchangeInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): Exchange {
    return new Contract(address, _abi, signerOrProvider) as Exchange;
  }
}
